<template>
  <div class="navbar">

    <hamburger
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />
    <div class="right-menu">
      <div class="msg" @click="toMessageCenter">
        <el-badge :hidden="(msg.newMsgNum != 0 ? false : true)" :value="msg.newMsgNum" :max="99">
          <i class="el-icon-message-solid" />
        </el-badge>
      </div>
      <div class="name">{{ name }}</div>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <el-avatar
            icon="el-icon-user-solid"
            :src="$store.getters.user.avatar"
          />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown" size="medium">
          <router-link to="/">
            <el-dropdown-item> 首页 </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided @click.native="userInformation">
            <span style="display: block">个人中心</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="dialogVisible = true">
            <span style="display: block">修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      :modal="true"
      :modal-append-to-body="false"
      width="38%"
    >
      <div>
        <el-form
          :ref="formPassword"
          label-position="right"
          label-width="115px"
          :model="formPassword"
          :rules="rules"
        >
          <el-form-item label="原密码:" prop="oldPassword">
            <el-input
              v-model="formPassword.oldPassword"
              :show-password="true"
            />
          </el-form-item>
          <el-form-item label="新密码:" prop="newPassword">
            <el-input
              v-model="formPassword.newPassword"
              :show-password="true"
            />
          </el-form-item>
          <el-form-item label="再次输入密码:" prop="repeatPassword">
            <el-input
              v-model="formPassword.repeatPassword"
              :show-password="true"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit(formPassword)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Hamburger from '@/components/Hamburger'
import { modifyUserPassword } from '@/api/modifyPersonalInformation/index.js'
export default {
  components: {
    // Breadcrumb,
    Hamburger
  },
  data() {
    return {
      dialogVisible: false,
      formPassword: {
        oldPassword: '',
        newPassword: '',
        repeatPassword: ''
      },
      // 校验规则
      rules: {
        oldPassword: [
          {
            required: true, // 是否必填
            message: '密码不能为空', // 规则提示
            trigger: 'submit' // 何事件触发
          },
          { max: 32, message: '密码长度不能超过32位' },
          { min: 6, message: '密码长度不能小于6位' }
        ],
        newPassword: [
          {
            required: true, // 是否必填
            message: '密码不能为空', // 规则提示
            trigger: 'submit' // 何事件触发
          },
          { max: 32, message: '密码长度不能超过32位' },
          { min: 6, message: '密码长度不能小于6位' }
        ],
        repeatPassword: [
          {
            required: true, // 是否必填
            message: '密码不能为空', // 规则提示
            trigger: 'submit' // 何事件触发
          },
          { max: 32, message: '密码长度不能超过32位' },
          { min: 6, message: '密码长度不能小于6位' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'name', 'msg'])
  },
  methods: {
    // 跳转到消息中心
    toMessageCenter() {
      // 根据路由name跳转
      this.$router.push({ name: 'MsgCenter' })
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$store.dispatch('msg/closeSocket')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    userInformation() {
      this.$router.push(`/personalInformation`)
    },
    submit(formName) {
      if (!(formName.newPassword === formName.repeatPassword)) return this.$message.error('两次密码输入不一致')
      this.$refs[formName].validate((valid) => {
        if (valid) {
          modifyUserPassword(formName).then((res) => {
            if (res.code === 200 && res.data) {
              this.dialogVisible = false
              this.$message.success('密码修改成功，请重新登录')
              this.$store.dispatch('user/logout')
              this.$router.push(`/login?redirect=${this.$route.fullPath}`)
            } else {
              this.$message.error('密码修改失败')
            }
          })
        } else {
          this.$message.error('请输入正确密码')
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }
    .msg {
      float: left;
      margin-right: 30px;
      line-height: 50px;
      cursor: pointer;
      ::v-deep {
        .el-badge__content.is-fixed {
          top: 10px;
          right: 5px;
        }
      }
    }
    .name {
      float: left;
      margin-right: 20px;
      line-height: 50px;
      cursor: pointer;
    }
    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;
      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        &:hover {
          cursor: pointer;
        }

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
.user-dropdown {
  width: 150px;
}
</style>
